/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {MigrationPreview} from '../models/MigrationPreview';
import type {UserSearchesReplaceRequest} from '../models/UserSearchesReplaceRequest';

export interface UserContentMigrationPreview$Request {
    userId: number;
    userSearchesReplaceRequest: UserSearchesReplaceRequest;
}

export interface UserContentMigrationPreview$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const userContentMigrationPreviewRequest = createAction<PayloadData<void, UserContentMigrationPreview$Request>>('USER_CONTENT_MIGRATION__USER_CONTENT_MIGRATION_PREVIEW__REQUEST');
export const userContentMigrationPreviewSuccess = createAction<PayloadData<MigrationPreview, UserContentMigrationPreview$Request>>('USER_CONTENT_MIGRATION__USER_CONTENT_MIGRATION_PREVIEW__SUCCESS');
export const userContentMigrationPreviewFailure = createAction<PayloadData<Error, UserContentMigrationPreview$Request, true>>('USER_CONTENT_MIGRATION__USER_CONTENT_MIGRATION_PREVIEW__FAILURE');

export const userContentMigrationPreviewActions = [
    userContentMigrationPreviewRequest,
    userContentMigrationPreviewSuccess,
    userContentMigrationPreviewFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserSearchesReplaceRequest} meta.userSearchesReplaceRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const userContentMigrationPreview = (meta: UserContentMigrationPreview$Request, config?: UserContentMigrationPreview$Config) => {
    return {
        CALL_API: {
            types: userContentMigrationPreviewActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/saved-searches/replace/preview`,
            TRANSPORT_REQUEST_BODY: meta.userSearchesReplaceRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

